var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M31.2889 16C31.2889 24.4438 24.4438 31.2889 16 31.2889C7.55618 31.2889 0.711111 24.4438 0.711111 16C0.711111 7.55618 7.55618 0.711111 16 0.711111C24.4438 0.711111 31.2889 7.55618 31.2889 16Z",
    stroke: "#0A142F",
    strokeWidth: 1.42222
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7201 20.903L14.7055 16.4252H12.8008V14.5061H14.7055V13.2267C14.7055 11.5001 15.7668 10.668 17.2956 10.668C18.0279 10.668 18.6573 10.7229 18.8407 10.7475V12.5519L17.7804 12.5524C16.949 12.5524 16.788 12.9504 16.788 13.5346V14.5061H19.15L18.5151 16.4252H16.788V20.903H14.7201Z",
    fill: "#0A142F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.8fc1f09d8d825791339b51ab153cd0bb.svg";
export { ForwardRef as ReactComponent };